import create from 'zustand';
import { mountStoreDevtool } from 'simple-zustand-devtools';
import testData from '../js/test-data/testData-final.js';

 /* eslint-env jquery */

const useStore = create((set) => ({
  setMatrixData: (data) => set(() => ({matrixData: data})),
  matrixData: testData,
  currentId: '',
  setCurrentId: (newId) => set(() => ({currentId: newId})),
  optionSelectionId: '',
  setOptionSelectionId: (newId) => set(() => ({optionSelectionId: newId})),
  checked: '',
  setChecked: (id) => set(() => ({checked: id})),
  questionLog: [],
  answerLog: [],
  addToLogs: (question, answer) => {
    set(state =>({
      questionLog: [...state.questionLog, question],
      answerLog: [...state.answerLog, answer]
    }))
  },
  removeLogs: () => {
    set(state => ({
      questionLog: state.questionLog.slice(0, state.questionLog.length-1),
      answerLog: state.answerLog.slice(0, state.answerLog.length-1),
    }))
  },
  pageLog: [],
  addToPageLog: (id) => {
    set(state =>({
      pageLog: [...state.pageLog, id]
    }))
  },
  removeFromPageLog: () => {
    set(state => ({
      pageLog: state.pageLog.slice(0, state.pageLog.length-1)
    }))
  },
  addingToPageLog: true,
  setAddingToPageLog: (bool) => set(() =>({addingToPageLog: bool})),
  summarySaveFunctionsReady: false,
  setSummarySaveFunctionsReady: (bool) => set(() =>({summarySaveFunctionsReady: bool})),
  showEmailModal: false,
  setShowEmailModal: (bool) => set(() => ({showEmailModal: bool})),
  showOptionTooltipModal: false,
  setShowOptionTooltipModal: (bool) => set(() => ({showOptionTooltipModal: bool})),
  tooltipContent: '',
  setTooltipContent: (html) => set(() => ({tooltipContent: html})),
  pdfLink: '',
  setPdfLink: (url) => set(() => ({pdfLink: url})),
  resetQuestionLog: () => set(() => ({questionLog: []})),
  resetAnswerLog: () => set(() => ({answerLog: []})),
  resetPageLog: () => set(() => ({pageLog: []})),
  pageContentsLoaded: false,
  setPageContentsLoaded: (bool) => set(() => ({pageContentsLoaded: bool})),
}))

/* Uncomment to see Zustand state in React dev tools */
/* First "npm i simple-zustand-devtools".  May need --legacy-peer-deps flag. */

// if (process.env.NODE_ENV === 'development') {
//   mountStoreDevtool('Store', useStore);
// }
if (process.env.NODE_ENV === 'production') {
  mountStoreDevtool('Store', useStore);
}

export default useStore;